import { commentsItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              瓜友热评
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
              百万吃瓜群众的真实声音
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {commentsItems.map((item, i) => (
              <div
                key={i}
                className="flex flex-col p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center text-accent-600 font-bold text-sm shrink-0">
                    {item.avatar.charAt(0)}
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">
                      {item.avatar}
                    </p>
                    <p className="text-xs text-foreground-400">{item.time}</p>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed flex-grow mb-4">
                  &ldquo;{item.content}&rdquo;
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line"></i>
                  <span>{item.likes}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}